import { createResource } from 'react-resource-router';
import type { loginAnnouncementsCardQuery } from 'view/login/login-announcements/__generated__/loginAnnouncementsCardQuery.graphql';
import LoginAnnouncementsCardQuery from 'view/login/login-announcements/__generated__/loginAnnouncementsCardQuery.graphql';
import FeatureGates from '@atlaskit/feature-gate-js-client';
import { createRelayResource } from '@atlassian/help-center-common-util/resource-router';

/**
 * This resource introduces a delay to ensure the brandingResource has enough time to load during login SSR
 * This is a hack until the brandingResource correctly communicates that it's done loading
 */
export const delayResource = createResource({
    type: 'RELAY_HELP_CENTER_DELAY',
    getKey: (_, { cloudId, helpCenterAri }: { cloudId: string; helpCenterAri: string }) => {
        return `static-delay${JSON.stringify({
            cloudId,
            helpCenterAri,
        })}`;
    },
    getData: () => {
        if (FeatureGates.checkGate('delay_login_ssr')) {
            return new Promise((resolve) => {
                // delay 200ms to allow other resources time to complete
                setTimeout(() => resolve(null), 200);
            });
        }
        return Promise.resolve(null);
    },
});

export const loginAnnouncementsCardResource = createRelayResource<loginAnnouncementsCardQuery>({
    type: 'HELP_CENTER_LOGIN_ANNOUNCEMENTS_CARD',
    getQuery: (_, { cloudId, helpCenterAri }: { cloudId: string; helpCenterAri: string }) => {
        return {
            parameters: LoginAnnouncementsCardQuery,
            variables: {
                cloudId,
                helpCenterAri,
            },
            options: {
                fetchPolicy: 'store-or-network',
            },
        };
    },
});
